import CalamitiesLogPageView from "./CalamitiesLogPageView"

function CalamitiesLogPage() {
    return <CalamitiesLogPageView />
}

export default CalamitiesLogPage;